import { render } from "./shop-sidebar-brands.vue?vue&type=template&id=b32d23d8&scoped=true"
import script from "./shop-sidebar-brands.vue?vue&type=script&lang=js"
export * from "./shop-sidebar-brands.vue?vue&type=script&lang=js"

import "./shop-sidebar-brands.vue?vue&type=style&index=0&id=b32d23d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32d23d8"]])

export default __exports__